import React from 'react';

export const MIKROTIK_MODEL_OPTIONS = Object.freeze([
    { value: 'hex-gr3', label: 'hEX (RB750Gr3)' },
    { value: 'hex-e50ug', label: 'hEX (E50UG)' },
    { value: 'hex-s', label: 'hEX S' },
    { value: 'hex-lite', label: 'hEX lite' },
    { value: 'hap-ax-lite', label: 'hAP ax lite' },
    { value: 'haplite', label: 'hAP lite' },
    { value: 'hap-ac2', label: 'hAP ac²' },
    { value: 'rb5009', label: 'RB5009' },
]);

export const MikrotikModelOptions = ({ placeholder = 'Select Platform' }) => (
    <>
        <option value="">{placeholder}</option>
        {MIKROTIK_MODEL_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>{label}</option>
        ))}
    </>
);
